import { EntityTypes } from "@vzbl/integrations";
import { useApplicationContext } from "src/hooks/useApplication";
import { IntegrationIcon } from "src/components/IntegrationIcon";
import { useEntityContext } from "../useEntityContext";
import { TabbedWork } from "../components/TabbedWork";
import { generateWorkTabs } from "../components/worktabs";
import { History, HistoryComponent } from "../History";
import { EntityScreen } from "./components/layout/Screen";
import { HeaderPanel } from "./components/layout/HeaderPanel";
import { ActionCard } from "./components/ActionCard";
import { SummaryTag } from "./components/Tags";
import { SummaryPanel } from "./components/layout/SummaryPanel";
import { InsightsPanel } from "./components/layout/InsightsPanel";
import { toHeaderAttributes } from "./components/HeaderAttributes";
import { EntityTabs } from "./components/EntityTabs";
import { Insights } from "../Insights";

export const DiscussionCommentEntity = () => {
  const orgId = useApplicationContext().org_id!;
  const context = useEntityContext();
  const properties = context.dataRef.current.entity.properties;
  const entityType = context.dataRef.current.entity.labels[0];

  return (
    <EntityScreen
      headerPanel={
        <HeaderPanel
          label={properties.name}
          entity={context.dataRef.current.entity}
          attributes={toHeaderAttributes({
            orgId,
            context,
            entityType,
            attributes: [
              {
                name: "created at",
                text: new Date(properties.createdAt).toLocaleString(),
              },
              {
                name: "language",
                text: properties.vzblLanguage,
              },
            ],
          })}
          icon={
            <IntegrationIcon source={properties.integration} size="large" />
          }
        />
      }
      summaryPanel={
        <SummaryPanel title={properties.name} description={properties.body} />
      }
      insightsPanel={
        <InsightsPanel
          cards={[
            <ActionCard
              key="category"
              badge={<SummaryTag />}
              label="Category"
              value={
                <div
                  style={{ textAlign: "center", fontWeight: 400, fontSize: 20 }}
                >
                  {properties.vzblCategory}
                </div>
              }
            />,
            <ActionCard
              key="tone"
              badge={<SummaryTag />}
              label="Tone"
              value={
                <div
                  style={{ textAlign: "center", fontWeight: 400, fontSize: 20 }}
                >
                  {properties.vzblTone}
                </div>
              }
            />,
            <ActionCard
              key="emotion"
              badge={<SummaryTag />}
              label="Emotion"
              value={
                <div
                  style={{ textAlign: "center", fontWeight: 400, fontSize: 20 }}
                >
                  {properties.vzblEmotion}
                </div>
              }
            />,
          ]}
        />
      }
    >
      <EntityTabs
        entity={context.dataRef.current.entity}
        propertiesSkipList={[
          "body",
          "branch",
          "createdAt",
          "name",
          "repository",
          "state",
          "vzblCategory",
          "vzblEmotion",
          "vzblLanguage",
          "vzblTone",
        ]}
        tabs={[
          {
            key: "overview",
            id: "overview",
            label: "Overview",
            children: <Insights entity={context.dataRef.current.entity} />,
          },
          {
            key: "history",
            id: "history",
            label: "History",
            children: (
              <History>
                <HistoryComponent />
              </History>
            ),
          },
          {
            key: "work",
            id: "work",
            label: "Work",
            children: (
              <TabbedWork
                items={generateWorkTabs(orgId, properties.uuid, [
                  { entityTypes: EntityTypes.Sprint },
                  { entityTypes: EntityTypes.IssueComment, label: "Comments" },
                  { entityTypes: EntityTypes.Commit },
                  {
                    entityTypes: EntityTypes.PullRequest,
                    label: "Pull Requests",
                  },
                  {
                    entityTypes: EntityTypes.CicdPipeline,
                    label: "Deployments",
                  },
                ])}
              />
            ),
          },
        ]}
      />
    </EntityScreen>
  );
};
